export class InternalError extends Error {
  constructor(message) {
    super()
    this.message = message
    this.name = this.constructor.name
  }
}
